import * as React from 'react';
import ReactYoutube, { Options } from 'react-youtube';

import PlayButton from '../../../../../assets/images/play-button.svg';
import { getYoutubeVideoId } from '../../../../../utils';
import { IEmbeddedVideoContent } from '../../../models';
import { Zoom } from '../Zoom';

import './index.scss';

interface IProps {
    content: IEmbeddedVideoContent;
    setSelectedSrc: (src: string) => void;
}

const options: Options = {
    playerVars: {
        autoplay: 1,
    }
};

export const EmbeddedVideo: React.FC<IProps> = ({ content: { photo, url }, setSelectedSrc }) => {
    const [isVideoPlayable, setVideoPlayable] = React.useState<boolean>(false);
    const [player, setPlayer] = React.useState();

    const query = getYoutubeVideoId(url);

    const onReady = (event: { target: any }): void => {
        setPlayer(event.target);
    };

    const pauseVideo = (): void => {
        if (player) {
            player.pauseVideo();
        }
    };

    return (
        <div className="embeddedVideo">
            <Zoom
                onClick={() => {
                    pauseVideo();
                    setSelectedSrc(url);
                }}
            />
            {isVideoPlayable ? (
                <ReactYoutube
                    opts={options}
                    className="embeddedVideo__video"
                    videoId={query[1]}
                    onReady={onReady}
                />
            ) : (
                <>
                    <img className="embeddedVideo__cover" src={photo} alt="" />
                    <img
                        alt=""
                        className="embeddedVideo__playButton"
                        src={PlayButton}
                        onClick={() => setVideoPlayable(true)}
                    />
                </>
            )}
        </div>
    );
};
